const flights = {
  flight: "Flug", // translated
  flights: "Flüge", // translated
  originDepartureDate: "Abfahrt", // translated
  destinationDepartureDate: "Zurückkehren", // translated
  outbound: "Ausgehend", // translated
  inbound: "Eingehende", // translated
  travelTime: "Reisezeit", // translated
  selected: "ausgewählt", // translated
  select: "wählen", // translated
  airline: "Fluggesellschaft", // translated
  directFlight: "Direktflug", // translated
  baggage: "Gepäck", // translated
  stops: "Stoppt", // translated
  nonStop: "Ohne Unterbrechung", // translated
  oneStopMax: "Eine Haltestelle max", // translated
  twoStopsMax: "Maximal zwei Stopps", // translated
  anyStops: "Mit allen Stopps", // translated
  smallBaggage: "Kleines Gepäck", // translated
  bigBaggage: "Großes Gepäck", // translated
  smallAndBigBaggage: "Kleines und großes Gepäck", // translated
  outboundStops: "Ausgehende Stopps", // translated
  inboundStops: "Eingehende Stopps", // translated
  selectAirline: "Wählen Sie Fluggesellschaft", // translated
  baggageOption: "Gepäckoption", // translated
  outboundDepartureAfter: "Hinflug danach", // translated
  outboundArrivalAfter: "Ankunft im Hinflug danach", // translated
  inboundDepartureAfter: "Rückflug danach", // translated
  inboundArrivalTimeAfter: "Ankunft im Inbound danach", // translated
  flightClass: "Flugklasse", // translated
  outboundDepAfter: "Abreise danach", // translated
  outboundArrivalAfrer: "Ankunft danach", // translated
  inboundDepAfter: "Im Abgang danach", // translated
  inboundArrivalAfter: "Bei der Ankunft danach", // translated
  airlines: "Fluggesellschaft(en)", // translated
  lessThan: "Weniger als", // translated
  layover: "Zwischenstopp", // translated
  duration: "Dauer", // translated
  economy: "Wirtschaft", // translated
  business: "Geschäft", // translated
  with: "Mit", // translated
  without: "Ohne", // translated
  twoOrMore: "Zwei oder mehr", // translated
  departure: "Abfahrt", // translated
  return: "Zurückkehren", // translated
  submit: "Einreichen", // translated
  priceLessThan: "Preis weniger als", // translated
  durationLessThan: "Dauer kürzer als", // translated
  layoverLessThan: "Zwischenstopp weniger als", // translated
  noLayover: "Kein Zwischenstopp", // translated
  durationLowestFirst: "Dauer (niedrigste zuerst)", // translated
  durationHighestFirst: "Dauer (höchste zuerst)", // translated
  idType: "ID-Typ", // translated
  idPassportCode: "ID-/Passcode", // translated
  expirationDate: "Verfallsdatum", // translated
  frequentFlyerNumber: "Vielfliegernummer", // translated
  frequentFlyerAirline: "Vielflieger Fluggesellschaft", // translated
  dateOfBirth: "Geburtsdatum", // translated
  infant: "Säugling", // translated
  phone: "Telefon", // translated
  title: "Titel", // translated
  noLuggageIncluded: "Kein Gepäck inbegriffen", // translated
  includesLuggage: "Inklusive Gepäck", // translated
  outboundFlight: "Hinflug", // translated
  inboundFlight: "Ankommender Flug", // translated
  flightNumber: "Flugnummer", // translated
  flightNumbers: "Flugnummern", // translated
  cabinClassType: "Kabinenklassentyp", // translated
  aircraftType: "Flugzeugtyp", // translated
  airlineName: "Name der Fluggesellschaft", // translated
  no: "NEIN", // translated
  yes: "Ja", // translated
  anyFlights: "Alle Flüge", // translated
  oneStop: "Ein Stop", // translated
  direct: "Direkte", // translated
  directFlights: "Direkte Flüge", // translated
  all: "Alle", // translated
  first: "Erste", // translated
  premiumEconomy: "Präm. Wirtschaft", // translated
  withBaggageOnly: "Nur mit Gepäck", // translated
  oneWay: "Ein Weg", // translated
  roundTrip: "Rundfahrt", // translated
  withBaggage: "Mit Gepäck", // translated
  noBaggage: "Kein Gepäck", // translated
  requiredFields: "Benötigte Felder", // translated
  nonRequiredFields: "Nicht erforderliche Felder", // translated
  cabinClass: "Kabinenklasse", // translated
  brandName: "Markenname", // translated
  performNewSearch: "Führen Sie eine neue Suche durch", // translated
  outboundDeparture: "Hinflug", // translated
  inboundDeparture: "Eingehende Abreise", // translated
  created: "Erstellt", // translated
  freeCancellationAvailable: "Kostenlose Stornierung möglich", // translated
  freeCancellationDeadline: "Kostenlose Stornierungsfrist", // translated
  externalReference: "Externe Referenz", // translated
  outboundflightNumber: "Nummer des Hinflugs", // translated
  inboundflightNumber: "Nummer des eingehenden Fluges", // translated
  arrival: "Ankunft", // translated
};

export default flights;
